/* Note: these styles will only apply to tour styles that we explicity render
within <TourStepContent>. Any broader card styles need to be applied to
client/web/ui/assets/css/shared/shepherd.css */

.illustration {
    /* The width of the shepherd card */
    width: 248px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: -20px;
    margin-left: -20px;
    margin-right: -20px;
    background-color: var(--blue-xlt);
    border-radius: 8px 8px 0 0;
    img,
    svg {
        border-radius: 8px 8px 0 0;
    }
}

.action-icon {
    min-width: 16px;
}
